import React from 'react';
import { usePreferences } from '../contexts/PreferencesContext';
import { Languages } from 'lucide-react';

const ScriptToggle = () => {
  const { scriptMode, setScriptMode } = usePreferences();

  return (
    <div className="flex items-center gap-2 bg-white rounded-lg p-1 shadow-sm border-2 border-stone-200">
      <button
        onClick={() => setScriptMode('phonetic')}
        data-testid="toggle-phonetic"
        className={`flex items-center gap-2 px-4 py-2 rounded-md font-nunito font-semibold transition-all ${
          scriptMode === 'phonetic'
            ? 'bg-primary text-white'
            : 'text-charcoal hover:bg-stone-100'
        }`}
      >
        <Languages className="w-4 h-4" />
        <span className="hidden sm:inline">Phonétique</span>
        <span className="sm:hidden">ABC</span>
      </button>
      <button
        onClick={() => setScriptMode('arabic')}
        data-testid="toggle-arabic"
        className={`flex items-center gap-2 px-4 py-2 rounded-md font-nunito font-semibold transition-all ${
          scriptMode === 'arabic'
            ? 'bg-secondary text-white'
            : 'text-charcoal hover:bg-stone-100'
        }`}
      >
        <span className="font-amiri text-lg">ع</span>
        <span className="hidden sm:inline">Arabe</span>
      </button>
    </div>
  );
};

export default ScriptToggle;
